import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle, vShow as _vShow } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("tr", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header, index) => {
      return (_openBlock(), _createElementBlock("td", {
        key: index,
        style: _normalizeStyle({ padding: `${_ctx.rowPaddingPx}px` })
      }, [
        (index === 0 && !_ctx.hideName)
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 0,
              "no-gutters": "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onNameClicked(_ctx.props.item))),
              style: {"cursor":"pointer"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "font-weight-medium pl-1"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.props.item.name), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_v_row, {
              key: 1,
              "no-gutters": "",
              class: "rounded d-flex justify-center",
              style: _normalizeStyle({
                    overflow: 'hidden',
                    cursor: 'pointer',
                    width: `${_ctx.rowItemWidth}px`,
                    margin: 'auto',
                })
            }, {
              default: _withCtx(() => [
                (_ctx.taxesSelectedContain('TVA'))
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: _ctx.nCols,
                      class: "ma-0"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives((_openBlock(), _createBlock(_component_v_avatar, {
                          tile: "",
                          color: _ctx.getColor(_ctx.props.item, 'TVA', header.value),
                          size: "25",
                          class: "pa-0 ma-0 avatarHover",
                          onClick: ($event: any) => (_ctx.onAvatarClicked(_ctx.props.item, 'TVA', header.value))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              "data-cy": "taxesRow-TVA",
                              class: _normalizeClass(
                                _ctx.getColor(_ctx.props.item, 'TVA', header.value) === _ctx.white
                                    ? 'text-grey font-weight-bold'
                                    : 'text-white font-weight-bold'
                            )
                            }, "T", 2)
                          ]),
                          _: 2
                        }, 1032, ["color", "onClick"])), [
                          [_directive_tooltip, _ctx.getDeclarationInfos(_ctx.props.item, 'TVA', header.value), "bottom"]
                        ])
                      ]),
                      _: 2
                    }, 1032, ["cols"]))
                  : _createCommentVNode("", true),
                (_ctx.taxesSelectedContain('IS'))
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 1,
                      cols: _ctx.nCols,
                      class: "ma-0"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives((_openBlock(), _createBlock(_component_v_avatar, {
                          tile: "",
                          color: _ctx.getColor(_ctx.props.item, 'IS', header.value),
                          size: "25",
                          class: "pa-0 ma-0 avatarHover",
                          onClick: ($event: any) => (_ctx.onAvatarClicked(_ctx.props.item, 'IS', header.value))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              "data-cy": "taxesRow-IS",
                              class: _normalizeClass(
                                _ctx.getColor(_ctx.props.item, 'IS', header.value) === _ctx.white
                                    ? 'text-grey font-weight-bold'
                                    : 'text-white font-weight-bold'
                            )
                            }, "I", 2)
                          ]),
                          _: 2
                        }, 1032, ["color", "onClick"])), [
                          [_directive_tooltip, _ctx.getDeclarationInfos(_ctx.props.item, 'IS', header.value), "bottom"]
                        ])
                      ]),
                      _: 2
                    }, 1032, ["cols"]))
                  : _createCommentVNode("", true),
                (_ctx.taxesSelectedContain('CVAE'))
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 2,
                      cols: _ctx.nCols,
                      class: "ma-0"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives((_openBlock(), _createBlock(_component_v_avatar, _mergeProps({
                          tile: "",
                          color: _ctx.getColor(_ctx.props.item, 'CVAE', header.value),
                          size: "25",
                          class: "pa-0 ma-0 avatarHover",
                          onClick: ($event: any) => (_ctx.onAvatarClicked(_ctx.props.item, 'CVAE', header.value)),
                          ref_for: true
                        }, _ctx.props), {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              "data-cy": "taxesRow-CVAE",
                              class: _normalizeClass(
                                _ctx.getColor(_ctx.props.item, 'CVAE', header.value) === _ctx.white
                                    ? 'text-grey font-weight-bold'
                                    : 'text-white font-weight-bold'
                            )
                            }, "C", 2)
                          ]),
                          _: 2
                        }, 1040, ["color", "onClick"])), [
                          [_directive_tooltip, _ctx.getDeclarationInfos(_ctx.props.item, 'CVAE', header.value), "bottom"]
                        ])
                      ]),
                      _: 2
                    }, 1032, ["cols"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["style"]))
      ], 4))
    }), 128)),
    _withDirectives(_createVNode(_component_oss_dialog, {
      modelValue: _ctx.actionDialog,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.actionDialog) = $event)),
      title: 'Que voulez-vous faire ?',
      "max-width": "800px"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_row, { "no-gutters": "" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "6",
              class: "pr-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn_primary, {
                  rounded: "",
                  block: "",
                  onClick: _ctx.onDialogRedirectClicked,
                  "data-cy": "AccountingClientMonitoring-redirection",
                  size: "x-large"
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("Aller sur la page")
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "6",
              class: "pl-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn_primary, {
                  rounded: "",
                  block: "",
                  onClick: _ctx.onDialogIgnoreClicked,
                  size: "x-large"
                }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode("Ignorer")
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]), [
      [_vShow, false]
    ])
  ]))
}